<template>
  <div>
    <Navbar />
    <section class="category-page">
      <Header
        formID="get-offer-dask"
        :formData="formData"
        :insuranceType="insuranceType"
        approveRoute="dask-teklif-onay"
      />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/component/categories/Header'
import GetQuote from '@/component/categories/GetQuote'
import categoryInfo from '@/component/categories/CategoryInfo'
import appContractedInsuranceCompanies from '@/component/contracted-insurance-companies/AppContractedInsuranceCompanies'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import DaskInsuranceData from '@/data/category-page-data/DaskInsurance.js'
import Footer from '@/component/footer/Footer'
import QuotationType from '@/data/QuotationType'
import { filteredButtons } from '@/mixins/FilteredButtons'

export default {
  metaInfo: {
    title: 'Online DASK Sorgula Zorunlu Deprem Sigortası Teklif Al',
    meta: [
      {
        name: 'description',
        content:
          'Online dask prim hesaplama, dask yaptırma, dask yenileme ve dask fiyatları için zorunlu deprem sigortası teklifi alarak en uygun deprem sigortasını seçin.'
      }
    ]
  },
  mixins: [filteredButtons],
  name: 'DaskInsurance',
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer
  },
  data () {
    return {
      insuranceType: QuotationType.DASK,
      categoryInfo: DaskInsuranceData.categoryInfo,
      getPrice: DaskInsuranceData.getPrice,
      faqTitle: DaskInsuranceData.faqTitle,
      faqTitleDesc: DaskInsuranceData.faqTitleDesc,
      questions: DaskInsuranceData.questions,
      formData: {
        description: {
          upperText: 'Doğru Ürün, Doğru Fiyat',
          title: 'Zorunlu Deprem Sigortası DASK Prim Hesaplama ',
          bottomText: 'Zorunlu Deprem Sigortası Teklifi Alın'
        },
        button: 'TEKLİF AL',
        fullname: true,
        identity: true,
        phone: true,
        email: true
      },
      quoteCard: {
        title: 'Alokasko İle DASK Sigortası Satın Almak Çok Kolay!',
        description:
          'Zorunlu Deprem Sigortası İle Depreme Karşı Hazırlıklı Olun.',
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: 'Bilgilerinizi Girin, Fiyat Teklif Formunu Doldurun',
            desc:
              'En doğru DASK sigortası tekliflerine kolayca ulaşmak için bilgilerinizi eksiksiz girin.'
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: '20’den Fazla Sigorta Şirketini Karşılaştırın',
            desc:
              'Saniyeler içinden birden fazla sigorta şirketinin fiyatlarını karşılaştırın.'
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'En Uygun Poliçeyi Anında Seçin',
            desc:
              'Çok sayıda mevcut fiyat teklifi arasından ihtiyaçlarınıza ve bütçenize en uygun olanı seçin.'
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Seçtiğiniz Poliçeyi Online Satın Alın',
            desc:
              'Kolay ödeme avantajı ile kredi kartına özel taksit imkânından yararlanın, poliçenizi hemen alın.'
          }
        ]
      }
    }
  },
  mounted () {
    this.filterButtons('Dask Sigortası')
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
